import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import nexapi from '../../services/api';
import { RequestModel } from '../../types/models/RequestModel';


interface RequestsState {
  data: RequestModel[];
  totalRecords: number;
  currentPage: number;
  loading: boolean;
  error: string | null;
  status: string | null;
}
interface RequestResponse {
  applications: RequestModel[]; // Change to ApplicationModel array instead of any[]
  totalCount: number;
}
const initialState: RequestsState = {
  data: [],
  totalRecords: 0,
  currentPage: 0,
  loading: false,
  error: null,
  status: 'idle',
};

export const fetchRequests = createAsyncThunk<RequestResponse, { page: number; numberOfRecord: number }>(
  'requests/fetchRequests',
  async ({ page, numberOfRecord }) => {
    try {
      const response = await nexapi.get(`/Configuration/GetAll?pagination=true&page=${page}&numberOfRecord=${numberOfRecord}`);
      const data = response.data;
      if (Array.isArray(data?.data)) {
        return {
          applications: data.data, // The list of applications
          totalCount: data.totalCount, // The total count of applications
        };
      } else {
        console.error("Invalid API Response:", data);
        return { applications: [], totalCount: 0 }; // Return a fallback structure
      }
    } catch (error) {
      console.error("API Call Failed:", error);
      return { applications: [], totalCount: 0 }; 
    }
  }
);

export const deleteConfiguration = createAsyncThunk('requests/deleteConfiguration', async (id: any) => {
  try {
    await nexapi.delete(`/Configuration/${id}`);
    return id;
  } catch (error) {
    return error.message
  }
});



const requestsSlice = createSlice({
  name: 'requests',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRequests.fulfilled, (state, action) => {
        // Assuming action.payload contains applications and totalCount
        state.data = action.payload.applications;
        state.totalRecords = action.payload.totalCount;
        state.status = 'succeeded';
      })
      .addMatcher(
        (action) => action.type.endsWith('/pending'),
        (state) => {
          state.status = 'loading';
        }
      )
      .addMatcher(
        (action) => action.type.endsWith('/rejected'),
        (state, action) => {
          state.status = 'failed';
        }
      );
  },
});

export default requestsSlice.reducer;